export default __webpack_public_path__ + "static/media/room1_3.ca00131a.jpeg";